"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function getUrlQuery(location, config) {
    var _a;
    var _b, _c, _d, _e;
    var query = {};
    var returnFullSearch = (_b = config === null || config === void 0 ? void 0 : config.returnFullSearch) !== null && _b !== void 0 ? _b : false;
    // For React Router v3 where location object has the query property
    if (location === null || location === void 0 ? void 0 : location.query) {
        return location.query;
    }
    // The window object is not available when doing SSR
    var windowSearch = '';
    if (typeof window !== 'undefined') {
        windowSearch = (_d = (_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.search) !== null && _d !== void 0 ? _d : '';
    }
    // Prefer the passed in location over the one from the window object
    var searchQuery = (_e = location === null || location === void 0 ? void 0 : location.search) !== null && _e !== void 0 ? _e : windowSearch;
    if (typeof searchQuery !== 'string' || searchQuery.length === 0) {
        return query;
    }
    // Ignore the `?` part of the query string e.g. ?nextUrl=home
    var search = searchQuery.substring(1);
    // Only split the first `=`. And keep the rest of the value.
    if (returnFullSearch) {
        var key = search.split(/=/)[0];
        var value = search.split(/=(.+)/)[1];
        return _a = {}, _a[key] = value, _a;
    }
    // Split the query string on `&`
    var queries = search.split('&');
    return queries.reduce(function (acc, query) {
        var _a;
        if (!query.includes('=')) {
            return {};
        }
        // For every query, split on `=`, to get the its key and value
        var _b = query.split('='), queryKey = _b[0], queryValue = _b[1];
        return __assign(__assign({}, acc), (_a = {}, _a[queryKey.trim()] = queryValue.trim(), _a));
    }, {});
}
exports.default = getUrlQuery;
